(ns ncr.nsql.locale
  (:require
   [tick.core :as t]
   [tick.locale-en-us]
   #?(:clj [taoensso.encore :refer [have have! have?]]
      :cljs [taoensso.encore :refer-macros [have have! have?]]))
  (:import
   #?(:clj [java.text DecimalFormat DecimalFormatSymbols])))

(def LOCALES
  {:default
   {:date ["yyyy-MM-dd"]
    :date/year-month ["yyyy-MM"]
    :date/year ["yyyy" "yy"]

    :decimal [{:pattern "#,##0.00"
               :decimal-separator \.
               :group-separator \,}]}

   :de
   {:date ["yyyy/MM/dd"]
    :date/year-month ["yyyy/MM"]

    :decimal [{:pattern "#,##0.00"
               :decimal-separator \,
               :group-separator \.}]}})

(def ^:private DATE-PARSERS
  {:date t/parse-date
   :date/year-month t/parse-year-month
   :date/year t/parse-year})

(defn- parse-date* [tag s fmt]
  (let [fmtr (t/formatter fmt)
        parse-fn (have! (DATE-PARSERS tag))]
    (try
      (parse-fn s fmtr)
      (catch java.time.format.DateTimeParseException _
        nil))))

(defn parse-date
  ([tag s] (parse-date tag s nil))

  ([tag s locale]
   (some #(parse-date* tag s %)
     (for [l (->> [locale :default] (filter some?) distinct)
           pattern (get-in LOCALES [l tag])
           :when pattern]
       pattern))))

#?(:clj
   (defn- decimal-format [{:keys [pattern decimal-separator group-separator]}]
     (doto
       (DecimalFormat. pattern
         (doto (DecimalFormatSymbols.)
           (.setDecimalSeparator decimal-separator)
           (.setGroupingSeparator group-separator)))
       (.setParseBigDecimal true)))

   :cljs
   (defn- decimal-format [_]
     (throw (ex-info "not implemented" {:name :decimal-format})))
   ;;
   )

(defn- parse-decimal* [s fmt]
  (try
    (.parse (decimal-format fmt) s)
    (catch #?(:clj java.text.ParseException :cljs js/Error) _
      nil)))

(defn parse-decimal
  ([s] (parse-decimal s nil))

  ([s locale]
   (some #(parse-decimal* s %)
     (for [l (->> [locale :default] (filter some?) distinct)
           pattern (get-in LOCALES [l :decimal])
           :when pattern]
       pattern))))

(comment
  (parse-date :date "2001-02-03") ; #time/date "2001-02-03"
  (parse-date :date/year-month "2001/02") ; nil
  (parse-date :date/year-month "2001/02" :de) ; #time/year-month "2001-02"
  (parse-date :date "2022/01/15" :de) ; #time/year-month "2001-02"

  (parse-decimal "123.45") ; 123.45M
  (parse-decimal "123,45") ; 12345M
  (parse-decimal "123,45" :de) ; 123.45M
  )
